import type {Config} from 'types/payload-types';

/** All supported locale codes, derived from the Payload Config type. */
export const SUPPORTED_LOCALES: Config['locale'][] = ['de', 'en'];

/**
 * Request-Header, über den der Proxy die Locale an App-Router-Seiten (z. B. `global-not-found`) weitergibt,
 * da dort das Locale-Präfix bereits aus dem Pfad entfernt ist.
 */
export const LOCALE_HEADER = 'x-locale';

/** The default locale used when none is specified. */
export const DEFAULT_LOCALE: Config['locale'] = 'de';

/** OG locale mapping for each supported locale. */
const OG_LOCALE_MAP: Record<Config['locale'], string> = {
    de: 'de_DE',
    en: 'en_US'
};

/** I18n translation key for each locale's display label. */
export const LOCALE_LABEL_KEYS: Record<Config['locale'], string> = {
    de: 'settings.languageDe',
    en: 'settings.languageEn'
};

/**
 * Maps a locale code to its Open Graph locale format.
 *
 * @param locale Locale code.
 * @returns OG locale string.
 */
export const toOgLocale = (locale: Config['locale']) => OG_LOCALE_MAP[locale];